import useSWR from "swr";

import { useMemo } from "react";

import type { Insight } from "models/insight";

import { geographiesUrl } from "components/InsightsListFilters/RegionsFilter";
import { baseFetcher } from "utils/baseFetcher";
import { getTopDownTicker } from "utils/insight";

const TopDownTicker = ({ insight }: { insight: Insight }) => {
  const { data: geographies } = useSWR(geographiesUrl, baseFetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const topDownTicker = useMemo(() => {
    if (!insight.topDownURL) return;

    if (!geographies?.length) return "";

    return getTopDownTicker(insight, geographies);
  }, [insight, geographies]);

  if (!insight.topDownURL || !topDownTicker) return <></>;

  return (
    <a href={insight.topDownURL}>
      <h3>{topDownTicker}</h3>
    </a>
  );
};

export default TopDownTicker;
